
export const setTitleFromSelectedOption = (el) => {
  if (el) {
    el.title = el.options[el.selectedIndex]?.text || '';
  }
};

export const getExceededCharacterLimitMessage = (
  isScheduleATourContentBoxLimitExceeded,
  isFeeDisclaimerLimitExceeded,
) => {
  const settingLabels = [
    isScheduleATourContentBoxLimitExceeded && 'Schedule a Tour Content Box',
    isFeeDisclaimerLimitExceeded && 'Fee Disclaimer',
  ].filter(Boolean);

  return `"${settingLabels.join('" and "')}" character limit${
    settingLabels.length > 1 ? 's' : ''
  } exceeded.`;
};

/**
 * safely retrieve values from deeply nested objects without having to
 * check for undefined values.
 * @param {Object} fn a function that wraps the unsafe behavior
 * @param {Object} defaulVal The default value returned
 */
export const getSafe = (fn, defaultVal = null) => {
  try {
    return fn();
  } catch (e) {
    return defaultVal;
  }
};

export const normalizeCompanies = (companies) =>
  companies.map(({ company_id, company_name }) => ({
    companyId: company_id,
    companyName: `${company_name} (${company_id})`,
  }));

export const normalizeLeasingTeams = (leasingTeams) =>
  leasingTeams.map((leasingTeam) => ({
    leasingTeamName: `${leasingTeam.leasing_team_name} (${leasingTeam.leasing_team_public_id})`,
    leasingTeamId: leasingTeam.leasing_team_id,
    leasingTeamPublicId: leasingTeam.leasing_team_public_id,
  }));

export const normalizeManagers = (managers) =>
  managers.map((manager) => ({
    label: `${manager.manager_first_name} ${manager.manager_last_name} - (${manager.manager_username})`,
    managerId: manager.manager_id,
    value: manager.manager_username,
  }));

export const getUpdatedPropertyPreferences = ({
  isChildPreference,
  propertyPreferences,
  settingName,
  value,
}) => ({
  ...propertyPreferences,
  ...(!isChildPreference && { [settingName]: value }),
  preferences: {
    ...propertyPreferences.preferences,
    ...(isChildPreference && { [settingName]: value }),
  },
});
